import { grey } from "@mui/material/colors";
import { PdfPrintFragment } from "Components/PdfTemplate/PdfPrintFragment";
import { PDF_BODY_FONT_FAMILY } from "Components/PdfTemplate/PdfTemplateTheme";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { format } from "date-fns";

const ZFPLogo = () => (
  <svg viewBox="0 0 1000 527.08" style={{ width: 48, height: 30, display: "block" }} role="img" aria-labelledby="zfp-logo-title">
    <title id="zfp-logo-title">ZFP Group</title>
    <polyline
      fill="#848587"
      points="8.34 221.52 105.15 86.86 16.07 86.86 16.07 44.86 167.4 44.86 167.4 77.02 69.4 213.47 173.66 213.47 173.66 255.48 8.34 255.48 8.34 221.52"
    />
    <polyline
      fill="#848587"
      points="209.3 44.86 356.46 44.86 356.46 84.48 259.93 84.48 259.93 136.61 349.89 136.61 349.89 173.25 259.93 173.25 259.93 255.48 209.3 255.48 209.3 44.86"
    />
    <path
      fill="#848587"
      d="M452.73,156.87h17.28c31.58,0,42.88-16.38,42.88-36.05,0-21.15-8.64-36.34-35.74-36.34h-24.42v72.39m-50.94-112.01h81.93c47.37,0,81.31,27.7,81.31,74.77,0,41.41-33.94,76.26-96.82,76.26h-15.48v59.58h-50.94V44.86Z"
    />
    <path
      fill="#848587"
      d="M0,425.73c0-65.31,37.16-103.6,104.44-103.6,33.22,0,47.86,6.48,58.26,10.7l-8.44,23.36c-12.66-3.66-23.93-8.17-49.54-8.17-39.69,0-73.76,21.14-73.76,74.89s35.75,78.55,78.55,78.55c11.82,0,20.25-1.97,26.44-2.82v-72.63h30.41v91.49c-18.85,6.21-35.74,9.57-61.92,9.57C38.84,527.08,0,487.67,0,425.73"
    />
    <path
      fill="#848587"
      d="M264.02,420.88c30.12,0,49.55-10.13,49.55-37.99s-13.8-37.44-42.79-37.44h-31.82v75.44h25.06m47.3,67.57l-32.67-45.32c-4.5,.83-10.97,1.12-16.31,1.12h-23.38v76h-30.39v-199.02h68.39c39.98,0,68.12,18.85,68.12,60.24,0,23.08-10.97,43.63-36.02,54.32l28.14,37.74c12.66,16.59,27.04,22.78,40.82,26.45l-6.75,23.36c-19.14-.83-41.67-10.7-59.96-34.89"
    />
    <path
      fill="#848587"
      d="M556.75,420.6c0-44.2-24.22-77.7-70.66-77.7s-71.5,33.5-71.5,77.13,22.23,78.82,69.53,78.82c50.39,0,72.63-34.06,72.63-78.26m-172.56-.28c0-62.49,41.36-101.92,104.42-101.92,66.46,0,98.82,43.92,98.82,102.48,0,61.64-38.28,102.74-104.16,102.74s-99.08-41.65-99.08-103.31"
    />
    <path
      fill="#848587"
      d="M620.97,439.69v-117.22h48.12v115.55c0,30.22,13.69,47.01,43.93,47.01s43.92-17.62,43.92-52.88v-109.68h46.74v110.52c0,69.11-46.44,90.94-90.65,90.94s-92.05-20.15-92.05-84.23"
    />
    <polyline fill="#848587" points="712.92 207.83 803.35 308.44 803.35 0 621.66 0 621.66 308.53 712.92 207.83" />
    <path
      fill="#848587"
      d="M894.53,427.68h16.23c29.65,0,40.27-15.41,40.27-33.87,0-19.86-8.11-34.14-33.56-34.14h-22.95v68.01m-47.85-105.21h76.94c44.48,0,76.38,26.02,76.38,70.24,0,38.89-31.9,71.61-90.93,71.61h-14.54v55.95h-47.85v-197.8Z"
    />
  </svg>
);

const SeparatorArrow = () => (
  <svg
    viewBox="0 0 20 20"
    style={{ height: 20, width: 20, display: "inline-flex", alignSelf: "center" }}
    role="presentation"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon
      points="4.59,16.59 6,18 14,10 6,2 4.59,3.41 11.17,10"
      fill="#dc6b2f"
      stroke="#ffffff"
      strokeWidth={1}
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);

export const PdfTemplateHeader = () => {
  const { t } = useResource();

  return (
    <PdfPrintFragment>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "92%",
          margin: "0 auto",
          padding: "8px 0",
          borderBottom: "2px solid rgb(133, 134, 135)",
          fontFamily: PDF_BODY_FONT_FAMILY,
          fontSize: 14,
          lineHeight: 1.3,
          color: grey[600],
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <ZFPLogo />

          <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
            <span style={{ fontWeight: 700 }}>{t(Resources.PdfTemplate.Header.Title)}</span>
            <SeparatorArrow />
            <span style={{ fontWeight: 300 }}>{t(Resources.PdfTemplate.Header.Questionnaire)}</span>
          </div>
        </div>

        <span style={{ fontWeight: 300 }}>{format(new Date(), "d. M. yyyy")}</span>
      </div>
    </PdfPrintFragment>
  );
};
